import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import { Input, Form, FormGroup, FormFeedback, Button, Card, CardBody, Spinner } from 'reactstrap';
import { userActions } from '../../actions';
import { selectRegistration } from '../../redux/modules/registerReducer';
import '../AuthForm.css';

const RegisterForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [user, setUser] = useState({
    email: '',
    password: '',
    isOptedIn: true
  });
  const registrationState = useSelector(selectRegistration);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "isOptedIn") {
      setUser({
        ...user,
        isOptedIn: event.target.checked
      });
      return;
    }

    setUser({
      ...user,
      [name]: value
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);

    if (user.email && user.password && user.isOptedIn) {
      dispatch(userActions.register(user, navigate));
    }
  };

  const registering = registrationState.registering;
  const invalidEmail = submitted && !user.email;
  const invalidPassword = submitted && !user.password;
  const invalidOptIn = submitted && !user.isOptedIn;

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <Card>
          <CardBody>
            <div className="auth-header">
              <h2>Create Your Account</h2>
              <p>Start protecting your online identity today</p>
            </div>

            <Form onSubmit={handleSubmit} className="auth-form">
              <FormGroup>
                <label className="form-label" htmlFor="email">Email Address</label>
                <Input
                  invalid={invalidEmail}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="you@example.com"
                  onChange={handleChange}
                />
                <FormFeedback>Email address is required</FormFeedback>
              </FormGroup>

              <FormGroup>
                <label className="form-label" htmlFor="password">Password</label>
                <Input
                  invalid={invalidPassword}
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Create a strong password"
                  onChange={handleChange}
                />
                <FormFeedback>Password is required</FormFeedback>
              </FormGroup>

              <div className="auth-checkbox">
                <Input
                  defaultChecked={true}
                  invalid={invalidOptIn}
                  type="checkbox"
                  name="isOptedIn"
                  id="isOptedIn"
                  onChange={handleChange}
                />
                <label htmlFor="isOptedIn">
                  I agree to the <Link to="/privacy-policy">Privacy Policy</Link> and <Link to="/terms-of-service">Terms of Service</Link>
                </label>
              </div>
              {invalidOptIn && (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  Please accept the terms to continue
                </div>
              )}

              <Button color="primary" disabled={registering} style={{ marginTop: '1.5rem' }}>
                {registering ? 'Creating Account...' : 'Create Free Account'}
              </Button>

              {registering && (
                <div className="auth-spinner">
                  <Spinner type="grow" />
                </div>
              )}

              <div className="auth-footer">
                <p>Already have an account? <Link to="/login">Sign in</Link></p>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default RegisterForm;
